
import moment from 'moment';

const state = {
  selectedDateRangePreset: {
    dateRange: {
      startDate: moment().startOf('month'),
      endDate: moment()
    }
  },
  isDateRangeUpdated: false
}
// getters
const getters = {
  selectedDateRangePreset: state => {
    return state.selectedDateRangePreset;
  },
  isDateRangeUpdated: state=>state.isDateRangeUpdated
}

// mutations
const mutations = {
  setDateRange(state, dateRange) {
    state.selectedDateRangePreset = {
      dateRange: {
        startDate: dateRange[0],
        endDate: dateRange[1]
      }
    };
  },
  setIsDateRangeUpdated(state, isDateRangeUpdated) {
    state.isDateRangeUpdated = isDateRangeUpdated
  }
}

const actions = {
  setDateRange(context, payload) {
    context.commit('setDateRange', payload)
  },
  setIsDateRangeUpdated(context, payload) {
    context.commit('setIsDateRangeUpdated', payload)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
